import { ExpedienteCorteEmmasa } from './expedienteCorteEmmasa.entity';
import { Factura } from './factura.entity';
import { ClienteContrato } from './ClienteContrato.entity';
import { InmuebleBO } from './inmueble.entity';
import { Length, MinLength } from 'class-validator';

export class Contrato {
    ContratosParticulares: Contrato[];
    ContratoComunitario: Contrato;
    Empadronados: number;
    NoEmision: boolean;
    PagadorDocIdenValidado: boolean;
    TitularDocIdenValidado: boolean;
    UsoCodigo: number;
    FecSolAlta: Date;
    FecSolBaja?: Date;
    NumeroFacturas?: number;
    ClienteContrato: ClienteContrato;
    Factura?: any;
    Uso?: any;
    TipoVip?: any;
    ServicioAgua?: any;
    Servicios?: any;
    Facturas: Factura[];
    FacturaeAdministracionPublica: boolean;
    FacturaeTipo: number;
    FacturaeEMail: string;
    FacturaeTipoEnvio: number;
    FacturaePortal: number;
    FacturaeUnidadTramitadora: string;
    FacturaeOrganismoGestor: string;
    FacturaeOficinaContable: string;
    FacturaeOrganoProponente: string;
    FacturaeMinimo: number;
    FacturaeActiva: boolean;
    ContratoComunitarioCodigo: number;
    MetodoCalculoComunitario: number;
    Codigo: number;
    CodigoNuevo: number;
    PendienteCobro: number;
    StrCodigoVersion: string;
    CodUsu: string;
    CodUsuAnu: string;
    CodigoInmueble: number;
    TitularCodigo: number;
    TitularTipoDoc: string;
    TitularDocIden: string;
    TitularNombre: string;
    TitularDireccion: string;
    TitularPoblacion: string;
    TitularProvincia: string;
    TitularCpostal: string;
    TitularNacion: string;
    TitularNacionalidad: string;
    @MinLength(1)
    PagadorTipoDoc: string;
    @Length(1, 12)
    PagadorDocIden: string;
    @Length(1, 100)
    PagadorNombre: string;
    @Length(1, 200)
    PagadorDireccion: string;
    @Length(1, 40)
    PagadorPoblacion: string;
    @Length(1, 40)
    PagadorProvincia: string;
    @Length(5)
    PagadorCpostal: string;
    @MinLength(1)
    PagadorNacion: string;
    @MinLength(1)
    PagadorNacionalidad: string;
    EnvioNombre: string;
    EnvioDireccion: string;
    EnvioCpostal: string;
    EnvioPoblacion: string;
    EnvioProvincia: string;
    EnvioNacion: string;
    Telefono1: string;
    RefTelefono1: string;
    Telefono2: string;
    RefTelefono2: string;
    Telefono3: string;
    RefTelefono3: string;
    Fax: string;
    RefFax: string;
    FContrato: string;
    FInicio: string;
    FRegistro: string;
    FAnulacion: Date;
    Email: string;
    CodCueCli: string;
    Version: number;
    EmPlaza: string;
    BatFila: number;
    BatColum: number;
    AvisoLector: string;
    ZonCod: string;
    Baja: boolean;
    Ruta1: string;
    Ruta2: string;
    Ruta3: string;
    Ruta4: string;
    Ruta5: string;
    Ruta6: string;
    Observaciones: string;
    LecturaUlt: number;
    NumeroChapa: string;
    RepresentanteLegal: string;
    VipTipoCodigo: number;
    AcometidaCodigo: string;
    SectorTecnicoCodigo: string;
    LecturaUltFec: string;
    @Length(1, 34)
    Iban: string;
    @Length(1, 11)
    Bic: string;
    ReferenciaMandato: string;
    Mandato?: any;
    DatosAdicionales: string[];
    InmuebleBO: InmuebleBO;
    EmplazamientoBO?: any;
    AcometidaBO?: any;
    SectorTecnicoBO?: any;
    UltimoContadorInstalado?: any;
    ZonaBO?: any;
    ClienteBO?: any;
    ClienteNombre: string;
    ClienteDireccion: string;
    CorrespondenciaDireccion: string;
    CorrespondenciaNombre: string;
    CorrespondenciaNacion: string;
    CorrespondenciaPoblacion: string;
    CorrespondenciaProvincia: string;
    CorrespondenciaCPostal: string;
    Ficticio: boolean;
    Estado: string;
    ExpedienteCorteEmmasaActivoBO: ExpedienteCorteEmmasa;
    ExistenReclamacionAbiertaBajaOficio: boolean;
  }
